import { useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { initDataUser, retrieveLaunchParams } from '@telegram-apps/sdk-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { UAParser } from 'ua-parser-js';
import { useShallow } from 'zustand/react/shallow';
import DistrictQuestion from '@components/forms/Survey/DistrictQuestion.component.jsx';
import SourceQuestion from '@components/forms/Survey/SourceQuestion.component.jsx';
import Button from '@components/ui/Button.component.jsx';
import { useFormErrors } from '@hooks/shared/useFormErrors.hook.js';
import { useSurveyStore } from '@stores/useSurveyStore.js';

function Survey({ className, afterSubmit }) {
  const {
    handleSubmit,
    control,
    formState: { errors, submitCount },
  } = useForm();

  const { t } = useTranslation();

  const { sendSurvey } = useSurveyStore(
    useShallow((state) => ({
      sendSurvey: state.sendSurvey,
      error: state.error,
    })),
  );

  const sourceRef = useRef(null);
  const districtRef = useRef(null);
  const fieldRefs = {
    source: sourceRef,
    district: districtRef,
  };

  function onSubmit({ source, district }) {
    const { tgWebAppPlatform, tgWebAppVersion } = retrieveLaunchParams();
    const { device, os } = UAParser(navigator.userAgent);

    const formattedData = {
      source: source,
      sector_locuiesti: district,
      chat_id: initDataUser().id,
      tgMetadata: {
        platform: tgWebAppPlatform,
        webAppVersion: tgWebAppVersion,
      },
      userAgent: {
        device: `${device?.vendor ?? 'No vendor'} ${device?.model ?? 'No model'}`,
        os: `${os.name} ${os.version}`,
      },
    };

    sendSurvey(formattedData).then(() => afterSubmit && afterSubmit());
  }

  useFormErrors(errors, submitCount, fieldRefs);

  return (
    <>
      <p className="text-center text-event-light text-lg leading-6 py-2 mb-2 break-words">
        {t('printer.form.description')}
      </p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={clsx('flex flex-col gap-3 mb-2', className)}
      >
        <SourceQuestion ref={sourceRef} control={control} errors={errors} />
        <DistrictQuestion ref={districtRef} control={control} errors={errors} />
        <Button
          className={'mb-40'}
          type={'submit'}
          variant={'tertiary'}
          buttonText={t('printer.form.button')}
        />
      </form>
    </>
  );
}

Survey.propTypes = {
  className: PropTypes.string,
};

export default Survey;
